import React from 'react';
import { generatePath, Redirect } from 'react-router';

const FullRedirect = ({ to, params = {} }) => {
  const destination = typeof to === 'string' ? to : to.compiledPath;

  return (
    <Redirect to={{
      pathname: generatePath(destination, params),
      // search: window.location.search,
    }}
    />
  );
};

export default FullRedirect;
